import { IApplicationState } from '../../types/redux';

export function selectRentPrice(state: IApplicationState) {
  return state.fieldsState.rentPrice;
}
